import styles from './stylesSummaryPanel.module.css';

const periodConstants = {
  SINGLE_TRANSACTION: 'Single Transaction',
  HOUR: 'Hour',
  DAY: 'Day',
  WEEK: 'Week',
  MONTH: 'Month',
  YEAR: 'Year',
  ALL_TIME: 'All Time',
};

function SummaryPanel({ data }) {
  const getPeriodLabel = (value) => {
    return periodConstants[value] || value;
  };

  return (
    <div className={styles.container}>
      <h3 className={styles.title}>Summary</h3>
      <div className={styles.underline}></div>

      <div className={styles.content}>
        <div className={styles.item}>
          <span className={styles.label}>Name</span>
          <span className={styles.value}>{data?.name}</span>
        </div>

        <div className={styles.item}>
          <span className={styles.label}>Min Transaction Amount</span>
          <span className={styles.value}>
            {data?.min_transaction_amount || 0}$
          </span>
        </div>

        <div className={styles.item}>
          <span className={styles.label}>Max Transaction Amount</span>
          <span className={styles.value}>
            ${data?.max_transaction_amount || 0}
          </span>
        </div>

        <div className={styles.item}>
          <span className={styles.label}>Number of Transactions</span>
          <span className={styles.value}>{data?.num_transactions || 0}</span>
        </div>

        <div className={styles.item}>
          <span className={styles.label}>Period</span>
          <span className={styles.value}>
            {getPeriodLabel(data?.period_type)}
          </span>
        </div>
      </div>
    </div>
  );
}

export default SummaryPanel;
